import {
  Add_New_Dates_For_Payment_Commission,
  Delete_Selected_Schedual_Date,
  Get_All_Schedual_Dates_Type,
  Get_Error,
  Get_Selected_Schedual_Date,
  GetAll_Payments_For_Commission_Pay_Type,
  Update_Selected_Schedual_Date_Type,
} from '../Types';

const intial = {
  Add_Payment_Date: [],
  Delete_Schedual_Date: [],
  Get_Selected_Payment_Date: [],
  Update_Selected_Payment_Date: [],
  Get_All_Commission_Payments: [],
  loading: true,
};

const Schedual_Commission_Dates_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_New_Dates_For_Payment_Commission:
      return {
        ...state,
        Add_Payment_Date: action.payload,
        loading: false,
      };

    case Get_All_Schedual_Dates_Type:
      return {
        ...state,
        Add_Payment_Date: action.payload,
        loading: false,
      };
    case Delete_Selected_Schedual_Date:
      return {
        ...state,
        Delete_Schedual_Date: action.payload,
        loading: false,
      };
    case Get_Selected_Schedual_Date:
      return {
        ...state,
        Get_Selected_Payment_Date: action.payload,
        loading: false,
      };
    case Update_Selected_Schedual_Date_Type:
      return {
        ...state,
        Update_Selected_Payment_Date: action.payload,
        loading: false,
      };

    // get All Payments
    case GetAll_Payments_For_Commission_Pay_Type:
      return {
        ...state,
        Get_All_Commission_Payments: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Add_Payment_Date: action.payload,
      };
    default:
      return state;
  }
};

export default Schedual_Commission_Dates_Reducer;
